export enum FieldStatus {
  neutral = 'neutral',
  critical = 'critical',
  positive = 'positive',
}

export type FieldStatusType = `${FieldStatus}`

interface FieldInputPropsWithLabel {
  label: string
  'aria-label'?: string
  'aria-labelledby'?: string
}

interface FieldInputPropsWithoutLabel {
  label?: undefined
  'aria-label': string
  'aria-labelledby'?: string
}

export type FieldInputWithOptionalLabelType<T> =
  | (T & FieldInputPropsWithLabel)
  | (T & FieldInputPropsWithoutLabel)
